import styled from 'styled-components';

import { MONTH_STATUS_STYLE } from './constants';

export const Wrapper = styled.div`
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    position: relative;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 14px;
    padding-bottom: 12px;
    border-bottom: 1px solid #eceff1;

    .title {
        font-size: 20px;
        font-weight: bold;
    }
`;

export const StatusBadge = styled.span`
    display: inline-block;
    padding: 3px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: bold;
    margin-left: 10px;
    background-color: ${(props) => (MONTH_STATUS_STYLE[props.status] || {}).background || '#90a4ae'};
    color: ${(props) => (MONTH_STATUS_STYLE[props.status] || {}).color || '#fff'};
`;

export const MonthNav = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;

    button {
        border: 1px solid #cfd8dc;
        background: #fff;
        border-radius: 4px;
        padding: 4px 12px;
        font-size: 13px;
        cursor: pointer;
    }

    button:hover {
        border-color: #1976d2;
        color: #1976d2;
    }
`;

export const Notice = styled.div`
    padding: 10px 14px;
    border-radius: 4px;
    margin-bottom: 14px;
    font-size: 13px;
    line-height: 1.7;
    background-color: ${(props) => props.background || '#fff8e1'};
    color: ${(props) => props.color || '#7a5b00'};
    border: 1px solid ${(props) => props.border || '#ffe082'};
`;

export const SummaryBar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 18px;
    padding: 12px 14px;
    margin-bottom: 14px;
    background-color: #f5f7f8;
    border: 1px solid #eceff1;
    border-radius: 6px;

    .item {
        display: flex;
        align-items: baseline;
        gap: 6px;
        font-size: 13px;
    }

    .item .label {
        color: #78909c;
    }

    .item .value {
        font-size: 18px;
        font-weight: bold;
    }
`;

export const ActionBar = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
    margin-top: 16px;
`;

export const PrimaryButton = styled.button`
    border: none;
    border-radius: 4px;
    padding: 8px 18px;
    font-size: 14px;
    font-weight: bold;
    cursor: pointer;
    color: #fff;
    background-color: ${(props) => props.tone || '#1976d2'};

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const GhostButton = styled.button`
    border: 1px solid #cfd8dc;
    background: #fff;
    border-radius: 4px;
    padding: 8px 16px;
    font-size: 14px;
    cursor: pointer;
    color: #37474f;

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const Legend = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin-top: 14px;
    padding: 10px 14px;
    background-color: #f8f9fa;
    border: 1px solid #eceff1;
    border-radius: 4px;
    font-size: 12px;

    .dot {
        display: inline-block;
        width: 12px;
        height: 12px;
        border-radius: 3px;
        margin-right: 6px;
        vertical-align: -1px;
    }
`;

export const LoadingMask = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1100;
    font-size: 14px;
`;
